import { createContext, useContext } from "react";
export var CoursePreviewContext = /*#__PURE__*/createContext(null);
export var useCoursePreviewContext = function useCoursePreviewContext() {
  var context = useContext(CoursePreviewContext);
  if (!context) {
    throw new Error('useCoursePreviewContext must be used within a CoursePreviewProvider');
  }
  return context;
};